import React, { ReactElement, useState } from 'react';
import { Label, SearchResults, SingleSelect } from 'idsk-react-components';
import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import CiselnikPolozka from '../../../model/CiselnikPolozka';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import useSearchValidPolozkyCiselnik
  from '../../NavrhAktuEuList/hooks/useSearchValidPolozkyCiselnik';
import {
  MAX_MULTISELECT_RESULT,
  SHOW_ALL_MAX_RESULT,
} from '../../../constants/MultiSelectConstant';

interface Props<T> {
  filter: T;
  filterCopy: T;
  onUpdateField: SafeParameterSetter<T>;
  onUpdateFieldCopy: SafeParameterSetter<T>;
  isNavrhAktuEu?: boolean;
}

const TypSingleSelect = <T extends { type?: CiselnikPolozka }, >({
  filterCopy,
  filter,
  onUpdateField,
  onUpdateFieldCopy,
  isNavrhAktuEu = false,
}: Props<T>): ReactElement => {
  const [searchText, setSearchText] = useState('');
  const [showList, setShowList] = useState<boolean>(false);
  const [limit, setLimit] = useState<number>(MAX_MULTISELECT_RESULT);

  const {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  } = useSearchValidPolozkyCiselnik(
    {
      kody: null,
      typy: [isNavrhAktuEu ? TypCiselnikaEnum.TypAktEu : TypCiselnikaEnum.TypDokumentuAktEu],
      ids: [],
      platny: true,
      hladanyNazov: filterCopy?.type?.nazov || searchText,
      limit,
    },
  );

  const handleSelectedItemChange = (item: CiselnikPolozka): void => {
    setShowList(false);
    if (item) {
      onUpdateField('type', item);
    }
    onUpdateFieldCopy('type', item);
  };

  return (
    <div className="slovlex-idsk-side-panel-input-wrapper">
      <Label className="blue-label">{isNavrhAktuEu ? 'Typ aktu' : 'Typ'}</Label>
      <SingleSelect
        id="typSingleSelect"
        name="typSingleSelect"
        searchText={searchText || ''}
        setSearchText={(text) => {
          setSearchText(text);
          setLimit(MAX_MULTISELECT_RESULT);
        }}
        selectedItem={filterCopy.type || null}
        setSelectedItem={handleSelectedItemChange}
        selectedItemValue={filter.type?.nazov || ''}
        visibilityMinSearchLength={0}
        showList={showList}
        setShowList={setShowList}
      />
      <SearchResults
        loadingShowAll={polozkyCiselnikStatus.loading}
        className="single-select-fazet"
        handleShowAll={() => {
          setLimit(SHOW_ALL_MAX_RESULT);
        }}
        withShowAllButton={(limit === MAX_MULTISELECT_RESULT
            && polozkyCiselnik.length === MAX_MULTISELECT_RESULT)
          || (limit === SHOW_ALL_MAX_RESULT && polozkyCiselnik.length <= MAX_MULTISELECT_RESULT)}
        setSearchText={(text) => {
          setSearchText(text);
          setLimit(MAX_MULTISELECT_RESULT);
        }}
        data={polozkyCiselnik}
        setSelectedItem={handleSelectedItemChange}
        dataAttributesToShow={[{ key: 'nazov', label: '' }]}
        type="column"
        size="m"
        visible={searchText.trim().length > 0 || showList}
      />
    </div>
  );
};

export default TypSingleSelect;
